import React, { FC, useEffect, useState } from "react";
import { PDFViewer, PDFViewerTool } from "@progress/kendo-react-pdf-viewer";
import { useParams } from "react-router";
import { getPdfApi, getPickListReportApi, getSoldFrozenWeeklyReportApi, getSoldFrozenDailyReportApi, getPurchaseStatisticsReportApi } from "api/pdf";
import { PickListFilter } from "api/pickList";
import { useInfoStore } from "store/error";
import { Loader } from "@progress/kendo-react-indicators";

const tools: PDFViewerTool[] = [
	"pager",
	"spacer",
	"zoomInOut",
	"zoom",
	"selection",
	"spacer",
	"search",
	//"open",
	"download",
	"print",
];

export const PdfViewer: FC<{}> = ({ }) => {
	const { id, type, guid } = useParams();
	const [pdfData, setPdfData] = useState<string>();
	const [loading, setLoading] = useState<boolean>(false);
	const { setError } = useInfoStore();
	const [filterOptions, setFilterOptions] = useState<PickListFilter>({
		take: 10000,
		skip: 0,
	});

	useEffect(() => {
		console.log("params: ", id, type, guid);

		if (type !== null && type !== undefined) {
			const storedFromDate = localStorage.getItem("fromDate");
			const storedToDate = localStorage.getItem("toDate");
			filterOptions.fromDate = storedFromDate ? new Date(storedFromDate) : undefined;
			filterOptions.toDate = storedToDate ? new Date(storedToDate) : undefined;
			filterOptions.buyerId = localStorage.getItem("buyerId") ?? undefined;
			filterOptions.vesselId = localStorage.getItem("vesselId") ?? undefined;

			if (type === "1") {
				setLoading(true);

				getPickListReportApi(filterOptions)
					.then((response) => {
						setPdfData(response);
					})
					.catch((err) => {
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					})
					.finally(() => {
						setLoading(false);
					});
			}
			else if (type === "2") {
				setLoading(true);

				getSoldFrozenWeeklyReportApi(filterOptions)
					.then((response) => {
						setPdfData(response);
					})
					.catch((err) => {
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					})
					.finally(() => {
						setLoading(false);
					});
			}
			else if (type === "3") {
				setLoading(true);

				getSoldFrozenDailyReportApi(filterOptions)
					.then((response) => {
						setPdfData(response);
					})
					.catch((err) => {
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					})
					.finally(() => {
						setLoading(false);
					});
			}
			else if (type === "4") {
				setLoading(true);

				getPurchaseStatisticsReportApi(filterOptions)
					.then((response) => {
						setPdfData(response);
					})
					.catch((err) => {
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					})
					.finally(() => {
						setLoading(false);
					});
			}


		} else {
			if (guid) {
				setLoading(true);
				getPdfApi(guid)
					.then((response) => {
						setPdfData(response);
					})
					.catch((err) => {
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					})
					.finally(() => {
						setLoading(false);
					});

				return;
			}
		}
	}, []);

	if (loading) {
		return (
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
				<Loader size="large" type="converging-spinner" />
			</div>
		);
	}

	return <PDFViewer data={pdfData} style={{ height: "100%" }} tools={tools} />;
};

export default PdfViewer;